import {createStore} from 'redux';
import reducer from './reducer.js';

export default createStore(reducer)


// WEBPACK FOOTER //
// ./src/Redux/store.js